export default __webpack_public_path__ + "i18n/translations/translation-da.ba75e615.json";